<template>
    <div>
        <div class="common-table">
            <el-table v-loading="loading" height="100%" :data="JPSystemChipLog.beanList" row-key="opTime">
                <el-table-column type="index" label="编号" align="center"/>
                <el-table-column label="玩家昵称" min-width="120" align="center" prop="userName"/>
                <el-table-column label="房间名称" min-width="120" align="center" prop="roomName"/>
                <el-table-column label="房间大小盲" min-width="120" align="center" prop="mangzhu"/>
                <el-table-column label="投入系统池数额" min-width="120" align="center" prop="contribution"/>
                <el-table-column label="投入时间" width="150" align="center" >
                  <template slot-scope="scope">{{scope.row.creatTime|getLocalTime}}</template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="JPSystemChipLog.total"
                :current-page="currentPage"
                @current-change="getList($event)"/>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                loading: false,
                currentPage:1
            }
        },
        computed: {
            ...mapState('market', ['JPSystemChipLog'])
        },
        methods: {
            ...mapActions('market', ['getJPSystemChipLog']),
            getList(page = 1) {
                this.loading = true;
                this.currentPage = page;
                this.getJPSystemChipLog(page).then(() => {
                    this.loading = false;
                })
            }
        }
    }
</script>
